import React from 'react';
import { Link } from 'react-router-dom';
import { FaPrint, FaArrowLeft } from 'react-icons/fa';
import logo from '../../assets/images/logo/logo-green.png';
import isoImg from '../../assets/images/about/iso.png';
import './CompanyProfile.css';

const profileRows = [
  ['Company Name', 'Tokyo Byokane Philippines Corporation'],
  ['Established', 'April 2000'],
  ['President', 'Mr. Ayumi Ishimoto'],
  ['Business Type', 'Logistics Enterprise (Trading / Warehousing)'],
  ['Capital', '— please provide'],
  ['Employees', '— please provide'],
  ['Business Hours', 'Monday–Friday, 8:00–17:00 PHT'],
  ['Head Office', 'Lot C2-6B Carmelray Industrial Park 2, Brgy. Punta, Calamba City, Laguna 4027, Philippines'],
  ['Telephone', '+63-49-508-7899 / 7903 / 7904'],
  ['Email', 'sales@tokyobyokane.com.ph'],
  ['Website', 'www.tokyobyokane.com.ph'],
];

const products = [
  'Standard Products (JIS / DIN / American fasteners)',
  'Precision Screws (#0 JCIS, #00 cross recess)',
  'Screw Machine Parts',
  'Thread Forming Screws (Taptites, trilobular)',
  'SEMS Screws (JIS with pre-assembled washers)',
  'Locking Parts (anti-vibration fasteners)',
  'Springs',
  'Cutting Parts',
  'Cold Heading Parts',
  'Plastic Parts',
];

const timeline = [
  ['1941', 'Tokyo Byokane founded in Japan as a trading shop serving Tokyo-based industries.'],
  ['2000', 'Tokyo Byokane Philippines Corporation established at Carmelray Industrial Park 2, Calamba, Laguna.'],
  ['Today', 'Part of the Tokyo Byokane Group — 20+ locations across 14 countries, serving mechanical and electrical industries worldwide.'],
];

const CompanyProfile = () => {
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="company-profile">
      <div className="company-profile__actions">
        <Link to="/about" className="company-profile__back-btn">
          <FaArrowLeft /> Back to About
        </Link>
        <button
          type="button"
          onClick={() => window.print()}
          className="company-profile__print-btn"
        >
          <FaPrint /> Save as PDF / Print
        </button>
      </div>

      <article className="company-profile__page">
        <header className="company-profile__header">
          <img src={logo} alt="Tokyo Byokane" className="company-profile__logo" />
          <div className="company-profile__header-title">
            <h1>Company Profile</h1>
            <p className="company-profile__subtitle">会社概要</p>
          </div>
          <div className="company-profile__meta">As of {today}</div>
        </header>

        <section>
          <h2>Overview</h2>
          <p>
            <strong>Tokyo Byokane Philippines Corporation (TBPC)</strong> is a trusted distributor
            of mechanical and electrical industrial fasteners, established in April 2000 at
            Carmelray Industrial Park 2, Calamba, Laguna. TBPC is part of the Tokyo Byokane Group —
            a global enterprise founded in Japan in 1941 and now operating across 14 countries. We
            serve as a one-stop shop for standard and precision fasteners, distributed from our
            Philippines warehouse to clients across Southeast Asia.
          </p>
        </section>

        <section>
          <h2>Company Details</h2>
          <table className="company-profile__table">
            <tbody>
              {profileRows.map(([label, value]) => (
                <tr key={label}>
                  <th scope="row">{label}</th>
                  <td>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section>
          <h2>History</h2>
          <div className="company-profile__timeline">
            {timeline.map(([year, text]) => (
              <div className="company-profile__timeline-item" key={year}>
                <span className="company-profile__timeline-year">{year}</span>
                <span className="company-profile__timeline-text">{text}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="company-profile__page-break">
          <h2>Products Distributed</h2>
          <p>TBPC distributes 10 product categories across mechanical and electrical applications:</p>
          <ul className="company-profile__list">
            {products.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
        </section>

        <section>
          <h2>Global Network</h2>
          <p>The Tokyo Byokane Group operates 20+ locations across 14 countries:</p>
          <ul className="company-profile__list">
            <li><strong>Headquarters:</strong> Japan, Singapore</li>
            <li><strong>Subsidiaries &amp; sales offices:</strong> USA, Mexico, Malaysia, Thailand, Indonesia, Vietnam, Hong Kong, China, Taiwan, Philippines</li>
            <li><strong>Manufacturing factories (sister companies):</strong> Philippines (Tokyo Steel Philippines), Vietnam, Thailand, China</li>
          </ul>
        </section>

        <section>
          <h2>Quality &amp; Environmental</h2>
          <p>
            <strong>Quality Policy:</strong> Continually improve products and services, effectively
            utilize available resources, and consistently comply with quality requirements.
          </p>
          <p>
            <strong>Environmental Policy:</strong> Manage environmental hazards to protect the
            environment, prevent pollution, and comply with environmental requirements including
            restrictions on prohibited chemical substances.
          </p>
          <div className="company-profile__certs">
            <img src={isoImg} alt="ISO Certification" />
            <div>
              <p><strong>ISO 9001</strong> · Quality Management System</p>
              <p><strong>ISO 14001</strong> · Environmental Management System</p>
            </div>
          </div>
        </section>

        <section>
          <h2>Contact</h2>
          <p><strong>Office &amp; Warehouse:</strong> Lot C2-6B Carmelray Industrial Park 2, Brgy. Punta, Calamba City, Laguna 4027, Philippines</p>
          <p><strong>Telephone:</strong> +63-49-508-7899 / 7903 / 7904</p>
          <p><strong>Email:</strong> sales@tokyobyokane.com.ph</p>
          <p><strong>Website:</strong> www.tokyobyokane.com.ph</p>
          <p><strong>Business Hours:</strong> Monday–Friday, 8:00–17:00 PHT</p>
        </section>

        <footer className="company-profile__doc-footer">
          <p>© {new Date().getFullYear()} Tokyo Byokane Philippines Corporation. All rights reserved.</p>
          <p className="company-profile__doc-footer-jp">東京鋲螺 · Fastening Your Innovations</p>
        </footer>
      </article>
    </div>
  );
};

export default CompanyProfile;
